<template>
  <div>
    <service-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj = "titleObj"
    ></service-header>
    <service-center></service-center>
    <service-footer :bottom="bottom" :bottomInfo="bottomInfo"></service-footer>
  </div>
</template>

<script>
import ServiceHeader from '@/components/mobile/Header'
import ServiceCenter from '@/components/mobile/ServiceCenter'
import ServiceFooter from '@/components/mobile/Footer'
export default {
  name: 'Service',
  data() {
    return {
      actIndex: 5,
      topStyle: "",
      imgList: [],
      bottom: {},
      logo: '',
      bottomInfo: {},
      titleObj:{},
      // background: require("../../static/images/service_mobile/banner.png"),
    }
  },
  components: {
    ServiceHeader,
    ServiceCenter,
    ServiceFooter,
  },
  mounted() {
    this.Pc_Mobile()
    this.getPageData()
    this.getHeaderImage()
    this.titleObj = { title: '服务中心', desc: '从软件开发到交付\n全程为客户提供优质化服务' }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.replace('/m_service');
      } else {
        this.$router.replace('/service');
      }
    },
    getPageData() {
      this.$http.post('home/index/m_aboutpag', null, (res) => {
        this.bottom = res.data.bottom[0]
        this.logo = this.bottom.logo
        // this.topStyle = "background-image:url('" + this.background + "')"
        this.bottomInfo = res.data.contact[0]
      })
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle =
              "background-image:url('" + res.data.phone_image + "')";
          }
        }
      );
    },
  }
}
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/mobile/Service.vue